/* eslint-disable react/no-unescaped-entities */
import { LegalPage, Section, BulletList } from "../components/LegalPage";

export default function AffiliateDisclosure() {
  return (
    <LegalPage
      title="Affiliate Disclosure"
      updated="26 February 2026"
      intro="We want you to understand how ShouldIBuyIt.co.uk makes money and why that does not influence the recommendations you see."
    >
      <Section title="1. We are an Amazon Associate">
        <p>
          ShouldIBuyIt.co.uk is a participant in the Amazon EU Associates Programme, an affiliate advertising
          programme designed to provide a means for sites to earn advertising fees by linking to Amazon.co.uk.
          When you click a "Find on Amazon" or "Buy on Amazon" button on this site and subsequently make a
          qualifying purchase, we receive a small commission from Amazon. <strong>You do not pay any more</strong>{" "}
          for the product as a result.
        </p>
      </Section>

      <Section title="2. How recommendations are generated">
        <BulletList items={[
          "The product the AI recommends is chosen on the basis of its suitability for the user's stated need — drawn from the model's training data on real-world product performance, reviews and feedback.",
          "We do NOT have a paid-placement programme. No brand, retailer or third party has paid us to feature their product.",
          "Whether an item carries an affiliate commission has no bearing on whether it is recommended. Many recommended items earn us nothing (out-of-stock listings, used items, or sales from non-eligible accounts).",
          "Alternatives shown alongside the main pick are selected to help you compare — typically one cheaper option and one premium upgrade.",
        ]} />
      </Section>

      <Section title="3. What our affiliate links look like">
        <p>
          Outbound Amazon links carry our Amazon Associates tag (currently <code className="text-foreground/90 bg-secondary/60 px-1.5 py-0.5 rounded text-sm">shouldibuy0e0-21</code>),
          marked with <code className="text-foreground/90 bg-secondary/60 px-1.5 py-0.5 rounded text-sm">rel="sponsored noopener noreferrer"</code> as recommended by the Competition and Markets Authority's
          guidance on hidden advertising.
        </p>
      </Section>

      <Section title="4. Prices and availability">
        <BulletList items={[
          "Prices displayed on this site are estimates intended as guidance only.",
          "Amazon prices and availability change frequently. Always confirm the listing on Amazon before purchasing.",
          "Where a recommended listing is replaced or removed by Amazon, our search-based fallback link may return a different but closely matching item — always check it is the product you want.",
        ]} />
      </Section>

      <Section title="5. Other affiliate relationships">
        <p>
          We do not currently participate in any other affiliate programme. If that changes we will disclose it
          here and on the relevant recommendation cards before any link is monetised.
        </p>
      </Section>

      <Section title="6. Why this disclosure exists">
        <p>
          UK consumer protection law and the CMA's "Hidden Ads" principles require websites to disclose paid
          relationships clearly, prominently and in plain language. This page is part of meeting that obligation;
          a short version is also shown directly under the search bar on the home page and in the footer of every
          page on this site.
        </p>
      </Section>

      <Section title="7. Contact">
        <p>
          Questions about our affiliate relationships or this disclosure?
          Email <a className="text-emerald-500 underline" href="mailto:hello@shouldibuyit.co.uk">hello@shouldibuyit.co.uk</a>.
        </p>
      </Section>
    </LegalPage>
  );
}
